import { useState } from "react";
import { Crown, LogIn, Zap } from "lucide-react";
import { useSiteAuth } from "@/components/GoogleAuth";
import { PlayerAuthModal } from "@/components/medusa/PlayerAuthModal";
import { levelProgress } from "@/components/medusa/player";

// Player identity chip — level, title, XP bar, streak. Guests get a sign-in prompt.
export function PlayerCard({ compact = false }) {
  const { user, profile } = useSiteAuth();
  const [authOpen, setAuthOpen] = useState(false);

  if (!user) {
    return (
      <>
        <button onClick={() => setAuthOpen(true)}
          className="inline-flex items-center gap-2 border border-purple-500/50 text-purple-300 rounded-full px-5 py-2 font-mono text-[10px] uppercase tracking-[0.15em] hover:bg-purple-500/10 transition-all"
          data-testid="player-signin-cta">
          <LogIn size={13} /> Sign in to save XP
        </button>
        {authOpen && <PlayerAuthModal onClose={() => setAuthOpen(false)} />}
      </>
    );
  }
  if (!profile) return null;
  const { level, into, needed } = levelProgress(profile.xp);
  return (
    <div className={`inline-flex items-center gap-4 border border-yellow-500/40 bg-yellow-950/10 rounded-2xl ${compact ? "px-4 py-2" : "px-5 py-3"}`} data-testid="player-card">
      <span className="w-9 h-9 rounded-full bg-gradient-to-br from-purple-500 to-fuchsia-500 flex items-center justify-center shrink-0">
        <Crown size={16} className="text-white" />
      </span>
      <div className="min-w-0">
        <p className="text-xs font-bold text-white truncate" data-testid="player-card-name">{profile.display_name}</p>
        <p className="font-mono text-[9px] uppercase tracking-[0.15em] text-yellow-300" data-testid="player-card-title">
          Lv {profile.level} · {profile.title}
        </p>
      </div>
      <div className="w-24 sm:w-32">
        <div className="h-1.5 rounded-full bg-white/10 overflow-hidden">
          <div className="h-full bg-gradient-to-r from-yellow-400 to-amber-500 transition-all duration-700" style={{ width: `${(into / needed) * 100}%` }} data-testid="player-xp-bar" />
        </div>
        <p className="mt-1 font-mono text-[9px] text-ice/40" data-testid="player-xp-text">{profile.xp.toLocaleString()} XP · {into}/{needed} to Lv {level + 1}</p>
      </div>
      {profile.streak?.count > 1 && (
        <span className="inline-flex items-center gap-1 font-mono text-[9px] uppercase tracking-[0.12em] text-emerald-300 shrink-0" data-testid="player-streak">
          <Zap size={11} /> {profile.streak.count}d
        </span>
      )}
    </div>
  );
}
